export const updateUrlPageParam = (nextPage: number) => {
  const currentSearchParams = new URLSearchParams(window.location.search)
  currentSearchParams.set('page', nextPage.toString())
  const newUrl = `${window.location.pathname}?${currentSearchParams.toString()}`
  window.history.replaceState(null, '', newUrl)
}
